export default __webpack_public_path__ + "static/media/submit_order_no.3a3af975.svg";